/* eslint-disable no-console */
import { Injectable } from '@angular/core';
/**
 * CmgBridgeService facilitates communication between Clear 1.0 and Clear 2.0
 */
@Injectable({
  providedIn: 'root',
})
export class RetailBridgeService {
  // When this is true, if the user navigates to a /clear1 route, a confirm modal will will be fired from the ExternalHostComponent.canDeactivate().
  clear1HasUnsavedChanges = false;
}
